// Copyright (C) 2017-2023 Smart code 203358507

const PlayIconCircleCentered = require('./PlayIconCircleCentered');

module.exports = PlayIconCircleCentered;
